export default {
  props: ['info', 'isCheck'],
  data: () => {
    return {
      tableList: [],
      form: {
        status: '',
        comments: ''
      }
    };
  },

  computed: {
    isTrust() {
      if (!this.info.category) return false;
      return this.info.category.indexOf('001') === 0;
    },
    isNongji() {
      if (!this.info.category) return false;
      return this.info.category.indexOf('003') === 0;
    },

    isShowSection() {
      if (this.info.tracking && this.info.tracking._id) {
        return true;
      }
      return false;
    }
  },

  methods: {

  }
};
